import '../css/app.css';
import $ from 'jquery';
import './modules/distributors';
import requestQuote from './modules/requestQuote';
import distributors from './modules/distributors';
import isocomhq from './isocomHQMap';
import carousel from './modules/carousel';
import logIn from './modules/logIn';
import search from './modules/search';
import modal from './modules/modal';
import mobileMenu from './modules/mobileMenu';
import mainMenu from './modules/mainMenu';
import mailingList from './modules/mailingList';
import contactForm from './modules/contactForm';
import dropdownCategory from './modules/dropdownCategory';
import forEachPolyfill from './modules/forEachPolyfill';
import 'cookieconsent';

$(() => {
  forEachPolyfill();
  distributors();
  isocomhq();
  carousel();
  logIn();
  search();
  modal();
  mobileMenu();
  mainMenu();
  mailingList();
  contactForm();
  dropdownCategory();

  let subNavigation = $('.subNavigation');

  if (subNavigation.length > 0) {
    let $sidebar = subNavigation,
      $window = $(window),
      offset = $sidebar.offset(),
      topPadding = 25;

    let stopPoint = $('footer').offset().top - $('.subNavigation ul').height() - 50;

    $window.resize(function () {
      stopPoint = $('footer').offset().top - $('.subNavigation ul').height() - 50;
    });

    $window.scroll(function () {
      if ($window.scrollTop() > offset.top && $window.scrollTop() < stopPoint && $(document).width() >= 820) { //down
        $sidebar.addClass('stuck');
        $sidebar.stop().animate({
          marginTop: $window.scrollTop() - offset.top + topPadding
        });
      }

      if ($window.scrollTop() <= offset.top && $window.scrollTop() < stopPoint && $(document).width() >= 820) { //up
        $sidebar.removeClass('stuck');
        $sidebar.stop().animate({
          marginTop: 0
        });
      }
    });
  }

  // DropDown | Show bottom section for Buy Tickets
  $('.c-DropDown').each(function () {
    var tis = $(this), state = false, answer = tis.parent().next('div').hide().css('height', 'auto').slideUp();
    tis.click(function (event) {
      event.preventDefault();
      state = !state;
      answer.slideToggle(state);
      tis.toggleClass('active', state);
    });
  });

  requestQuote();
});



// WEBPACK FOOTER //
// ./themes/app/assets/js/app.js